export const initSpotHeader = () => {
	const spotHeaderSlider = document.querySelector( 'section.cds2-spot-header ul.slides' );

	if ( !spotHeaderSlider )
	{
		return;
	}

	const slides = Array.from( spotHeaderSlider.children );

	if ( slides.length < 2 )
	{
		return;
	}

	let currentIndex = 0;

	setInterval( () => {
		spotHeaderSlider.querySelector( 'li.current' ).classList.remove( 'current' );
		currentIndex++;

		if ( currentIndex >= slides.length )
		{
			currentIndex = 0;
		}

		slides[currentIndex].classList.add( 'current' );
	}, 5000 );

	const spotHeaderCards = document.querySelector( 'section.cds2-spot-header div.spot-info' );

	if ( !spotHeaderCards )
	{
		return;
	}

	spotHeaderCards.addEventListener( 'click', ( evt ) => {
		const cardAnchor = evt.target.closest( 'a' );
		
		if ( !cardAnchor )
		{
			return;
		}

		evt.preventDefault();
		
		const requestedElement = document.querySelector( cardAnchor.getAttribute( 'href' ) );

		if ( !requestedElement )
		{
			return;
		}

		const initialDistance = Math.round( requestedElement.getBoundingClientRect().top - document.querySelector( 'header' ).offsetHeight - 20 );
		let closedDistance = 0;

		const pathInterval = setInterval( () => {
			const diff = initialDistance - closedDistance;

			if ( diff > 0 )
			{
				window.scrollBy( 0, diff > 100 ? 100 : diff );
				closedDistance += 100;
			}
			else
			{
				clearInterval( pathInterval );
			}
		}, 25 );
	} );
};